import { onProfileObjChange, onAuthorizationChange, onSubscriptionChange,onHistoryObjChange } from "./account";

export default {
  onProfileObjChange,
  onAuthorizationChange,
  onSubscriptionChange,
  onHistoryObjChange,
};
